import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const eiwrsSiteInventoryServices = {
  //Site Inventory
  getStudyEIWRSSiteInventory,
  assignUnassignStudyDepotSite,
  getAssignedDepotBySite,
  getDepotBySite,
  getAvailableSiteKit,
  downloadSiteKitReport
};

// Get Study EIWRS Site Inventory
async function getStudyEIWRSSiteInventory(studyId, mode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEIWRSSiteInventory/${studyId}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEIWRSSiteInventory/${studyId}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Assign and Unassign Study Depot Site
async function assignUnassignStudyDepotSite(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudyDepotSite`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Assigned Depot by Site
async function getAssignedDepotBySite(studyId, siteId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedDepotBySite/${studyId}/${siteId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Depot by Site
async function getDepotBySite(studyId, siteId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getDepotBySite/${studyId}/${siteId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Site Kit Report
async function downloadSiteKitReport(studyId, siteId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}downloadSiteKitReport/${studyId}/${siteId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Available Site Kit
async function getAvailableSiteKit(studyId, siteId, subjectId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAvailableSiteKit/${studyId}/${siteId}/${subjectId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}